/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface UpsertStudioPromoCodeRequest
 */
export interface UpsertStudioPromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertStudioPromoCodeRequest
     */
    code: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpsertStudioPromoCodeRequest
     */
    discountKind: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertStudioPromoCodeRequest
     */
    value: number;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpsertStudioPromoCodeRequest
     */
    maxUses: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpsertStudioPromoCodeRequest
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the UpsertStudioPromoCodeRequest interface.
 */
export function instanceOfUpsertStudioPromoCodeRequest(value: object): value is UpsertStudioPromoCodeRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('discountKind' in value) || value['discountKind'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('maxUses' in value) || value['maxUses'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function UpsertStudioPromoCodeRequestFromJSON(json: any): UpsertStudioPromoCodeRequest {
    return UpsertStudioPromoCodeRequestFromJSONTyped(json, false);
}

export function UpsertStudioPromoCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertStudioPromoCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'discountKind': json['discountKind'],
        'value': json['value'],
        'maxUses': ActorActivityRecordActorUserIdFromJSON(json['maxUses']),
        'isActive': json['isActive'],
    };
}

export function UpsertStudioPromoCodeRequestToJSON(json: any): UpsertStudioPromoCodeRequest {
    return UpsertStudioPromoCodeRequestToJSONTyped(json, false);
}

export function UpsertStudioPromoCodeRequestToJSONTyped(value?: UpsertStudioPromoCodeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'discountKind': value['discountKind'],
        'value': value['value'],
        'maxUses': ActorActivityRecordActorUserIdToJSON(value['maxUses']),
        'isActive': value['isActive'],
    };
}

